// WPI staff typeahead for task assignment — Microsoft Graph /users with the
// delegated User.ReadBasic.All scope (admin-consented on the WISE CRM app
// regs 2026-07-13). Live GAL, no server round-trip through our API.

import type { IPublicClientApplication, AccountInfo } from '@azure/msal-browser';

export interface PersonHit {
  name: string;
  email: string;
  title?: string;
}

export async function searchPeople(
  instance: IPublicClientApplication,
  account: AccountInfo,
  query: string,
): Promise<PersonHit[]> {
  const q = query.trim().replace(/'/g, "''");
  if (q.length < 2) return [];
  let accessToken: string;
  try {
    ({ accessToken } = await instance.acquireTokenSilent({ account, scopes: ['User.ReadBasic.All'] }));
  } catch (err) {
    // Newly-consented scope can demand interaction once — try a popup before
    // giving up (the caller surfaces failures to the user either way).
    const { InteractionRequiredAuthError } = await import('@azure/msal-browser');
    if (err instanceof InteractionRequiredAuthError) {
      ({ accessToken } = await instance.acquireTokenPopup({ account, scopes: ['User.ReadBasic.All'] }));
    } else {
      throw err;
    }
  }
  const filter = `(startswith(displayName,'${q}') or startswith(mail,'${q}') or startswith(userPrincipalName,'${q}') or startswith(givenName,'${q}') or startswith(surname,'${q}')) and accountEnabled eq true`;
  const url = `https://graph.microsoft.com/v1.0/users?$filter=${encodeURIComponent(filter)}&$select=displayName,mail,jobTitle&$top=8&$count=true`;
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${accessToken}`, ConsistencyLevel: 'eventual' },
  });
  if (!res.ok) throw new Error(`Graph people search failed (${res.status})`);
  const body = (await res.json()) as { value: { displayName: string; mail: string | null; jobTitle: string | null }[] };
  return body.value
    .filter((u) => u.mail)
    .map((u) => ({ name: u.displayName, email: u.mail as string, title: u.jobTitle ?? undefined }));
}

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
